<template>
	<k-editor-form v-if="account">
		<template v-slot:left>
			<div v-for="(group, index) in groups" :key="index">
				<div>
					<h4>{{group.name}}</h4>
				</div>
				<k-layout style="min-height: 30px;">
					<k-flex c2>Channels:</k-flex>
					<k-flex c10>
						<k-chip size="xs" v-for="(channel, idx) in get_channels(group.channels)" :key="'ch'+idx">{{channel.type}}: {{channel.title}}</k-chip>
					</k-flex>
				</k-layout>

				<k-layout style="min-height: 30px;">
					<k-flex c2>Content lists:</k-flex>
					<k-flex c10>
						<k-chip size="xs" v-for="(cms_list, idx) in get_cms_lists(group.cms_lists)" :key="'cms'+idx">{{cms_list.name}}</k-chip>
					</k-flex>
				</k-layout>

				<k-layout style="min-height: 30px;"> 
					<k-flex c2>Content list types:</k-flex>
					<k-flex c10>
						<k-chip size="xs" v-for="(cms_list_type, idx) in get_cms_list_types(group.cms_list_types)" :key="'type'+idx">{{cms_list_type.name}}</k-chip>
					</k-flex>
				</k-layout>

				<k-layout style="min-height: 30px;">
					<k-flex c2>Events:</k-flex>
					<k-flex c10>
						<k-chip size="xs" v-for="(event, idx) in get_events(group.events)" :key="'ev'+idx">{{event}}</k-chip>
					</k-flex>
				</k-layout>
			</div>
		</template>
	</k-editor-form>
</template>

<script>
export default {
  props: ['id'],
  components: {
  },
  data () {
    var ch = this.$cloudserver.channel("accounts:"+(this.id||"create"));
    return {
      ws_channel: ch,
      account: this.convertAccount(ch.data)
    }
  },
  watch: {
		"ws_channel.data": {
			handler(newVal, oldVal) {
				if(typeof(newVal) != "undefined") {
					this.account = this.convertAccount(newVal, oldVal);
				}
			},
			deep: true
		},
		'$route' (to, from) {
			if(typeof(from.meta.edit) != "undefined" && to.name == from.meta.edit) {
				this.ws_channel = this.$cloudserver.channel("accounts:"+(this.id||"create"));
				this.ws_channel.join();
			}
		}
	},
  created() {
    this.ws_channel.join();
  },
  computed: {
    is_edit () {
      return typeof(this.account) != "undefined" && this.account.id != null;
    },
    groups () {
    	var self = this;
    	return _.map(this.account.groups, (group_uuid) => {
    		return self.$store.state.groups_uuid[group_uuid] || {};
    	});
    }
  },
  methods: {
  	get_channels (channels) {
  		var self = this;
  		return _.map(channels, (channel_uuid) => {
  			return self.$store.state.channels_uuid[channel_uuid];
  		})
  	},
  	get_cms_lists (cms_lists) {
  		var self = this;
  		return _.map(cms_lists, (id) => {
  			return self.$store.state.cms_lists[id];
  		})
  	},
  	get_cms_list_types (cms_list_types) {
  		var self = this;
  		return _.map(cms_list_types, (id) => {
  			return self.$store.state.cms_list_types[id];
  		})
  	},
  	get_events (events) {
  		var self = this;
  		return _.map(events, (event_uuid) => {
  			return event_uuid;
  		})
  	},
    convertAccount (newVal, oldVal) {
      var account = _.cloneDeep(newVal);
      if(typeof(oldVal) != "undefined") {
        //TODO: Tähän muuttuneen datan tarkistus ja ilmoitus
      }

      if(typeof(account) == "undefined" || _.isEmpty(account)) return undefined;

      return account;
    }
  }
}
</script>
